<!-- 范围数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box" v-if="scope.index == 0">
                        <!-- 主要信息 -->
                        <el-form label-width="100px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                           <el-row>
                              <el-form-item label="范围名称" prop="scopeName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('范围名称')" v-html="'范围名称'"></label>
                                 <el-input class="form_codition" clearable v-model.trim="sendDataInfo.scopeName" :maxlength="$store.state.inputLength"></el-input>
                              </el-form-item>
                              <el-form-item label="助记码">
                                 <label slot="label" :style="$common.labelStyle('助记码')" v-html="'助记码'"></label>
                                 <el-input class="form_codition" v-model.trim="sendDataInfo.scopeCode" clearable :maxlength="$store.state.inputLength"></el-input>
                              </el-form-item>
                              <el-form-item label="范围类型" prop="scopeType" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('范围类型')" v-html="'范围类型'"></label>
                                 <el-select class="form_codition" v-model="sendDataInfo.scopeType" placeholder="请选择范围类型" clearable>
                                    <el-option v-for="item in scopeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                 </el-select>
                              </el-form-item>
                              <el-form-item label="排序" prop="scopeType" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                 <label slot="label" :style="$common.labelStyle('排序')" v-html="'排序'"></label>
                                 <el-input class="form_codition" v-model.trim="sendDataInfo.scopeSort" clearable :maxlength="$store.state.inputLength"></el-input>
                              </el-form-item>
                           </el-row>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <div class="foots">
               <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="$emit('drawerCancel')">取消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>

         </div>
      </div>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
   name: "scopeManagementAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            scopeName: "",
            scopeType: 0, //	范围类型0.生产范围1.经营范围2.诊疗范围
            scopeSort: 0,
            scopeCode: "",
         },
         tabForm: [],
         showTabs: "",
         DialogVisible: false, //检索
         seId: "",
         seWidth: "",
         seTitle: "",
         seType: "",
         isLoaded: false,
         scopeList: [
            {
               value: 0,
               label: "生产范围",
            },
            {
               value: 1,
               label: "经营范围",
            },
            {
               value: 2,
               label: "诊疗范围",
            },
         ], //范围类型列表
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.scopeName": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.scopeCode =
               this.$common.createPinyinCode(newValue,this.sendDataInfo.scopeCode);
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, type) {
         this.seId = sId;
         this.seType = type;
         this.DialogVisible = true;
      },
      //提取返回
      changeInputModel(val) {
         // console.log(val)
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      tableRowClassName({ row, rowIndex }) {
         row.index = rowIndex;
      },

      //确认新增
      sendDataAction(formName1) {
         this.$refs[formName1].validate((valid) => {
            if (valid) {
               // console.log('sendDataInfo', this.sendDataInfo)
               this.sub();
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         var responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.dictscopeAddScope(this.sendDataInfo);
         } else if (this.dataActionBox.actionType == 1) {
            responseData = await this.$http.dictscopeUpdateScope(this.sendDataInfo);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel");
            // this.dataActionBox.showStatus = false
            // this.$parent.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //取消
      initActionBox(formName1) {
         var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
         this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel");
               // this.$parent.getDataList()
               this.init();
               this.$refs[formName1].resetFields();
            })
            .catch(() => { });
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "scopeType"||key=='scopeSort') {
               this.sendDataInfo[key] = 0;
            } else {
               this.sendDataInfo[key] = "";
            }
         }
      },
      //父级传入
      openBox(cate, formData, oldData = "") {
         this.showTabs = this.dataActionBox.boxTitle + '范围'
         this.init();
         if (cate == 0) {
            this.dataActionBox.boxTitle = "新增";
            this.dataActionBox.openMode = "ltr";
         } else if (cate == 1) {
            this.dataActionBox.boxTitle = "编辑";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         } else {
            this.dataActionBox.boxTitle = "查看";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         }
         this.filterMainField()
         this.dataActionBox.actionType = cate;
         this.dataActionBox.showStatus = true;
      },
      // 过滤表单不同类型
      filterMainField() {
         this.tabForm = [
            {
               jciName: this.dataActionBox.boxTitle + '范围信息',
               jurconfigform: []
            }
         ]
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         var params = this.actionData;
         this.openBox(params.cate, params.formData, params.oldData);
         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}
</style>
